import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React from 'react'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
export default function KeyHighlights({title,location1,location}) {
    const JoinOurCourse = [
        {
            img:"/new-course-details/key/flexible.webp",
            title:`Flexible Learning Framework`,
            cnt:`The combination of platform and Ease of Learning offers modern-day students a chance to enhance and customize their learning in the most effortless manner possible.`,
            alt:`Flexible Learning For ${title} Classes In ${location}`
            
        },
        {
            img:"/new-course-details/key/learn.webp",
            title:`Learn from Expert Trainers`,
            cnt:`Learn from culture-changing trainers who brings a wealth of experience from the workplace. Learn practical skills and tactics that will assure success in your field.`,
            alt:`Expert Trainer for ${title} Training `
        },
        {
            img:"/new-course-details/key/classes.webp",
            title:`Unlimited Practical Classes`,
            cnt:`Learn from above mentioned culture changing trainers without limit through enhanced sessions meant to sharpen your skills in a practical manner on a continuous basis.`,
             alt:`Unlimited Practical Classes for ${title} Training`
        },
        {
            img:"/new-course-details/key/internship.webp",
            title:`Internship Opportunity`,
            cnt:`Usher into your career with relevant industry experience through our internship program. You'll be assigned projects to work on while also benefiting from one-on-one mentoring to prepare you for various challenges.`,
           alt:`Internship Opportunity with ${title} Training`
        },
        {
            img:`/new-course-details/key/guidence.webp`,
            title:"Interview & Career Guidance",
            cnt:`Accomplish great heights in your career with interview tips and proper training with defined career goals achieved under his personal guidance.`,
            alt:`${title} Training with Interview and Career Guidence`

        },
        {
            img:"/new-course-details/key/job-opportunities.webp",
            title:`Endless Job Opportunities`,
            cnt:`Jump start your career with a multitude of job offers where one can find numerous job opportunities and build a successful career without limits.`,
            alt:`Endless Job Opportunities with ${title} Training`
        }, 

    ]
  return (

     
   <>
   <section className='join-bg'>
    <div className='container'>
    <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>Key Features of <span className={`ylw-clr fs-30 tfs-28 mfs-21  fwb600 ${popins.className}`}>{title} {location1}</span>  </h2>
    <div className=' df fw fjsb mfdc'>
       {JoinOurCourse.map((items,index)=>{
        return(
        <div className='df gap10 w30p mt32 tmt28 mmt20 mwap' key={index}>
             <Image src={items.img} width={40} height={40} alt={items.alt} loading='lazy'/>
            <div className=''>
            <h3 className={`fs-16 mfs-15 fwb500 ${popins.className}`}>{items.title}</h3>
            <p className={`fs-16 mfs-15 fwb400 mt20 ${quickSand.className}`}>{items.cnt}</p>
            </div>
        </div>
     )})}
      
    </div>
    </div>
   </section>
   <style jsx>
  {`
  .join-bg{
   padding: 70px 0px;
  } 
@media only screen and (min-width:768px) and (max-width: 1023px){
  .join-bg{
   padding: 40px 0px;
  } 

  }
  @media only screen and (max-width:767px){
  .join-bg{
   padding: 30px 0px;
  } 
  }
  `}

   </style>
   </>

)
}
